export default "__VITE_ASSET__D8A1pOan__"